import { ContentSpinner } from '@taxbit-private/cosmic'
import { Navigate } from 'react-router-dom'

import { useAuth } from 'contexts/auth/AuthContext'

export const OAuthCallback: React.FC = () => {
  const { isLoading } = useAuth()
  /* TODO: Fix returnTo state */
  return isLoading ? <ContentSpinner /> : <Navigate to="/" />
}

export default OAuthCallback
